import React from 'react';
import classNames from 'classnames';

import css from './IconSupportChat.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconSupportChat = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M19.9997 36.6666C29.2044 36.6666 36.6663 29.2047 36.6663 19.9999C36.6663 18.3396 36.4236 16.736 35.9716 15.2226C35.8781 14.9096 35.509 14.7837 35.2216 14.9387C34.1635 15.5094 32.9528 15.8333 31.6663 15.8333C27.5242 15.8333 24.1663 12.4754 24.1663 8.33325C24.1663 7.04684 24.4902 5.83606 25.0609 4.77803C25.2159 4.49057 25.0899 4.1215 24.777 4.02803C23.2636 3.57603 21.66 3.33325 19.9997 3.33325C10.7949 3.33325 3.33301 10.7952 3.33301 19.9999C3.33301 22.6661 3.95903 25.186 5.07211 27.4207C5.3679 28.0146 5.46636 28.6934 5.29487 29.3343L4.30219 33.0443C3.87126 34.6549 5.3447 36.1283 6.95525 35.6974L10.6653 34.7047C11.3062 34.5332 11.985 34.6317 12.5789 34.9275C14.8136 36.0406 17.3335 36.6666 19.9997 36.6666Z"
        fill="#A9DBFB"
      />
      <ellipse cx="31.667" cy="8.33325" rx="5" ry="5" fill="#A9DBFB" />
    </svg>
  );
};

export default IconSupportChat;
